import { render, staticRenderFns } from "./ListaTimes.vue?vue&type=template&id=58a8b4b6&scoped=true&"
import script from "./ListaTimes.vue?vue&type=script&lang=js&"
export * from "./ListaTimes.vue?vue&type=script&lang=js&"
import style0 from "./ListaTimes.vue?vue&type=style&index=0&id=58a8b4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a8b4b6",
  null
  
)

export default component.exports